// 接口地址
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

// 网站配置存储的名称
export const WEBSITE_CONFIG_STORE_NAME = 'website_config';

// 浏览器编码存储的名称
export const BROWSER_STORE_NAME = 'api_browser_code';

// 二维码生成器存储的名称
export const QRCODE_STORE_NAME = 'api_qrcode_token'

// 当前城市存储的名称
export const CITY_STORE_NAME = 'city';